import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as PartnersActions from '../actions/partners.actions';
import { PartnersEntity } from '../models/partners.models';

export const PARTNERS_FEATURE_KEY = 'partners';

export interface State extends EntityState<PartnersEntity> {
  selectedId?: string | number; // which Partners record has been selected
  loaded: boolean; // has the Partners list been loaded
  error?: string | null; // last known error (if any)
  // error?: PartnersError | null; // last known error (if any)
}

export interface PartnersPartialState {
  readonly [PARTNERS_FEATURE_KEY]: State;
}

export const partnersAdapter: EntityAdapter<PartnersEntity> =
  createEntityAdapter<PartnersEntity>();

export const initialState: State = partnersAdapter.getInitialState({
  loaded: false
});

const partnersReducer = createReducer(
  initialState,
  on(PartnersActions.loadPartners, (state) => ({
    ...state,
    loaded: false,
    error: null
  })),
  on(PartnersActions.loadPartnersDataSuccess, (state, { partners }) => {
    return partnersAdapter.upsertOne(partners, { ...state, loaded: true });
  }),
  on(PartnersActions.loadPartnersDataFailure, (state, { error }) => {
    return partnersAdapter.upsertOne(error, { ...state, loaded: true });
  }),
  on(
    PartnersActions.loadAEMErrorMessagesSuccess,
    (state, { aemErrorMessages }) =>
      partnersAdapter.upsertOne(aemErrorMessages, {
        ...state,
        loaded: true
      })
  ),
  on(
    PartnersActions.loadPartnersPromotionsDataSuccess,
    (state, { partnersPromotions }) => {
      return partnersAdapter.upsertOne(partnersPromotions, {
        ...state,
        loaded: true
      });
    }
  ),
  on(PartnersActions.loadPartnersPromotionsDataFailure, (state, { error }) => {
    return partnersAdapter.upsertOne(error, { ...state, loaded: true });
  })
);

export function reducer(state: State | undefined, action: Action) {
  return partnersReducer(state, action);
}
